import { ErrorWrapper } from './util'
import { API_URL } from '../.env'
import { OdooService } from './odoo.service'

const MODEL = 'account.move'

// const REQUIRED_FIELDS = ['id']
const BASIC_FIELDS = [
  'id',
  'journal_id',
  'type',
  'afip_auth_code',
  'afip_auth_code_due',
  'afip_auth_mode',
  'afip_auth_verify_observation',
  'afip_auth_verify_result',
  'afip_auth_verify_type',
  'afip_barcode',
  'afip_barcode_img',
  'afip_batch_number',
  'afip_cae',
  'afip_cae_due',
  'afip_xml_request',
  'afip_xml_response',
  // 'l10n_ar_afip_service_start',
  // 'l10n_ar_afip_service_end',
  // 'l10n_ar_afip_responsibility_type_id',
  // 'l10n_ar_afip_concept',
  // 'l10n_ar_afip_barcode',
  'amount_total',
  'date',
  'display_name',
  'name',
  'narration',
  'document_number',
  'invoice_date',
  'invoice_date_due',
  'invoice_line_ids',
  'invoice_origin',
  'invoice_payment_state',
  'invoice_payment_term_id',
  'invoice_sent',
  'partner_id',
  'state',
  'x_is_enrollment',
  'x_neptuno_id'
]

export class AccountMoveService extends OdooService {
  // eslint-disable-next-line no-useless-constructor
  constructor () {
    super()
  }

  static get entity () {
    return 'fields'
  }

  static API_URL () {
    return API_URL
  }

  static async list (domain, opts = {}) {
    try {
      return await this.kwSearchRead(MODEL, domain, BASIC_FIELDS, opts)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async read (ids, fields) {
    try {
      return await this.kwRead(MODEL, ids, [...BASIC_FIELDS, ...fields])
    } catch (error) {
      console.log(error)
    }
  }

  static async search (domain) {
    try {
      return await this.kwSearch(MODEL, domain, BASIC_FIELDS)
    } catch (error) {
      console.log(error)
    }
  }

  static async create (data) {
    try {
      return await this.kwCreate(MODEL, data)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async delete (id) {
    try {
      return await this.kwDelete(MODEL, id)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async update (id, data) {
    try {
      // console.log(data)
      return await this.kwUpdate(MODEL, id, data)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }

  static async execute (method, params) {
    try {
      console.log(method, params)
      return await this.kwExecute(MODEL, method, params)
    } catch (error) {
      console.log(error)
      throw new ErrorWrapper(error)
    }
  }
}
